/**
 * The ONE definition of the URL a just-created team review is opened at.
 *
 * Extracted from LiveReviewModal.onSuccess (2026-08-22) when a second caller
 * appeared: the Schedule page's Capture Issues row action creates a review
 * with no modal at all, and two hand-built query strings would have drifted
 * the moment either surface gained a param. Moved from the dashboard into
 * @overlayqa/shared (2026-10-19) when the extension's Open in team review
 * button became the third caller (background/liveReviewBridge.ts).
 *
 * None of these params is cosmetic:
 *  - `s=` is the auth handoff. The review page is served from the API origin,
 *    where the dashboard's Clerk cookie may not reach (prod app. -> api.
 *    split), so WITHOUT this the page falls back to the guest/client bundle
 *    instead of the authenticated team UI.
 *  - `liveAvailable` drives the review page's mode-indicator dropdown.
 *  - `ext=1` tells the page the extension is present.
 *  - `workflow=` is allowlisted server-side by parseOpenWorkflow and opens
 *    that panel on mount.
 *
 * Param ORDER is pinned by a CONTROL test against the string the modal built
 * before the extraction (packages/dashboard/src/lib/__tests__/createdReviewUrl.test.ts),
 * because harnesses and the review page both read these back.
 */
/**
 * Build the full review URL, or null when the server returned no shareUrl.
 *
 * Returning null rather than a best-effort string is deliberate: the modal
 * guarded on `if (url)` and a caller that navigates to "null" is worse than
 * one that reports the create as failed.
 */
export function buildCreatedReviewUrl(input) {
    const { shareUrl, liveAvailable, extensionDetected, authHandoff, openWorkflow } = input;
    if (!shareUrl)
        return null;
    const separator = shareUrl.includes('?') ? '&' : '?';
    const extParam = extensionDetected ? '&ext=1' : '';
    const handoffParam = authHandoff ? `&s=${encodeURIComponent(authHandoff)}` : '';
    const workflowParam = openWorkflow ? `&workflow=${encodeURIComponent(openWorkflow)}` : '';
    return `${shareUrl}${separator}liveAvailable=${liveAvailable ?? false}${extParam}${handoffParam}${workflowParam}`;
}
//# sourceMappingURL=createdReviewUrl.js.map